<template>
  <Toast position="top-right"/>
  <AppNavbar/>
  <router-view/>
</template>

<script setup>
import Toast from 'primevue/toast'
import AppNavbar from '@/shared/ui/AppNavbar.vue'
import { onMounted, onUnmounted, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/modules/auth/store/auth.store'
import { usePermissionsStore } from '@/modules/auth/store/permissions.store'
import { initializeSession, refreshSession } from '@/modules/auth/services/session.service'
import { clearUserScopedState } from '@/modules/auth/services/user-scoped-state.service'
import {
  closeAuthChannel,
  subscribeToAuthChanges
} from '@/modules/auth/services/auth-channel.service'
import { canAccessRoute } from '@/app/router/guards'

const router = useRouter()
const authStore = useAuthStore()
const permissionsStore = usePermissionsStore()

let unsubscribeFromAuthChanges = null

function getUserId(user) {
  const userId = user?.id ?? user?.Id ?? null
  return userId === null ? null : String(userId)
}

watch(
  () => getUserId(authStore.user),
  (currentUserId, previousUserId) => {
    if (currentUserId === previousUserId) {
      return
    }

    clearUserScopedState()
  },
  { flush: 'sync' }
)

async function revalidateCurrentRoute() {
  await refreshSession()

  const currentRoute = router.currentRoute.value

  if (
    !canAccessRoute(currentRoute, authStore, permissionsStore) &&
    currentRoute.path !== '/home'
  ) {
    await router.replace('/home')
  }
}

onMounted(() => {
  unsubscribeFromAuthChanges = subscribeToAuthChanges(() => {
    revalidateCurrentRoute().catch(() => {})
  })

  initializeSession()
})

onUnmounted(() => {
  unsubscribeFromAuthChanges?.()
  closeAuthChannel()
})
</script>
